import { setRegularSearchText } from '@/features/campaigns/campaignsSlice';
import { SearchInput } from '@/global/components';
import { RootState } from '@/reducers';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const CampaignsTableSearch: FC = () => {
  const { t } = useTranslation();

  return (
    <div className='flex justify-end'>
      <SearchInput
        stateSelector={(state: RootState) => state.campaigns.ui.regular.searchText}
        stateUpdater={setRegularSearchText}
        placeholder={t('campaign:searchCampaignByName')}
      />
    </div>
  );
};
